import { cn } from "@/lib/utils";
import Lottie from "lottie-react";

import emptyAnimation from "./empty.json";
import { useGlobalStore } from "@/GlobalStore";
import { PlatformType } from "@/types";

type Props = {
  className?: string;
  showDescription?: boolean;
};

const platformLabelMap = {
  [PlatformType.FACEBOOK]: "Meta",
  [PlatformType.TIKTOK]: "TikTok",
  [PlatformType.GOOGLE]: "Google",
  [PlatformType.LINKEDIN]: "LinkedIn",
};

const NothingToShow = ({ className, showDescription = true }: Props) => {
  const { selectedAccount } = useGlobalStore();
  const platformLabel = platformLabelMap[selectedAccount?.platform as PlatformType];
  return (
    <div className={cn("flex flex-col items-center justify-center", className)}>
      <div className="w-[160px]">
        <Lottie
          animationData={emptyAnimation}
          loop={true}
          autoplay={true}
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      <div className="text-[12px] font-medium text-brand-primary-800">
        Nothing to show
      </div>
      {showDescription && (
        <div className="text-[12px] text-brand-primary-600">
          {platformLabel} Ads is silent for these dates, try a broader range.
        </div>
      )}
    </div>
  );
};

export default NothingToShow;
